import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import useRouteMatch from '~/hooks/useRouteMatch';
import PerlaIcon from '~/icons/icon-perla.svg?react';
import NavigationSidebarItem from '~/layouts/dashboard/navigation/NavigationSidebarItem';
import { RouteConfig } from '~/routes/routeConfig';
import { useIsSubmenuOpen } from '~/state/navigationSidebar';

const AiChatItem: React.FC = () => {
  const { t } = useTranslation('sidebar', { keyPrefix: 'aichat' });
  const isSubmenuOpen = useIsSubmenuOpen('aichat');

  const href = RouteConfig.Chat.buildLink();
  const isActive = Boolean(useRouteMatch([href]));

  return (
    <NavigationSidebarItem
      href={href}
      iconComponent={PerlaIcon}
      title={t('label')}
      isActive={isActive}
      isSubmenuOpen={isSubmenuOpen}
    />
  );
};

export default memo(AiChatItem);
